<div class="col-12 md:col-10 lg:col-8 xl:col-5 m-auto px-4 md:px-0">
    <div *ngIf="messagesAvailable" class="w-full flex align-items-center justify-content-center">
        <p-message
            *ngFor="let msg of messagesAvailable; let i = index; trackBy: trackByIndex"
            [severity]="msg.severity"
            [text]="msg.text"
            class="w-full flex justify-content-center"
            styleClass="w-full pt-3 pb-3"
            data-auto-id="find-plan-error-messages"
        ></p-message>
    </div>
    <app-registration-stepper *ngIf="!auth0Userid" [currentStep]="1"></app-registration-stepper>
  <div class="flex justify-content-center mb-2">
      <p-card class="col-12 sm:col-11 md:col-10 xl:col-12 justify-content-center">
          <ng-template pTemplate="title">
            Let's locate your plan
          </ng-template>
          <p class="m-0 mb-3">Choose one of the following options to find or add your plan:</p>

          <div class="form-field-same-line p-fieldset row searchPlanButtons px-2">
              <div class="col-4 md:col-4 p-1">
                  <p-button
                      label="Phone"
                      [rounded]="true"
                      styleClass="{{activeLayout===findPlanConstants.PHONE ?
                          'bg-blue-100 text-blue-700 w-full border-blue-200': 'w-full'}}"
                      severity="secondary"
                      variant="outlined"
                      icon="pi pi-phone"
                      size="small"
                      data-auto-id="phone-button"
                      (click)="changeContainer(findPlanConstants.PHONE)" />
              </div>
              <div class="col-4 md:col-4 p-1">
                  <p-button
                      label="Address"
                      [rounded]="true"
                      styleClass="{{activeLayout===findPlanConstants.PROPERTY ?
                          'bg-blue-100 text-blue-700 w-full border-blue-200': 'w-full'}}"
                      severity="secondary"
                      variant="outlined"
                      icon="pi pi-home"
                      size="small"
                      data-auto-id="property-button"
                      (click)="changeContainer(findPlanConstants.PROPERTY)"
                  />
              </div>
              <div class="col-4 md:col-4 p-1">
                  <p-button
                      [rounded]="true"
                      styleClass="{{activeLayout===findPlanConstants.CONTRACT ?
                          'bg-blue-100 text-blue-700 w-full border-blue-200': 'w-full'}}"
                      data-auto-id="plan-button"
                      severity="secondary"
                      variant="outlined"
                      size="small"
                      (click)="changeContainer(findPlanConstants.CONTRACT)"
                  >
                  <i class="pi pi-hashtag hidden md:block"></i> Plan Number
                  </p-button>
              </div>
          </div>

          <form [formGroup]="findPlanForm">
              <ng-container [ngSwitch]="activeLayout">
                  <ng-container *ngSwitchCase=findPlanConstants.PHONE>
                      <div class="col-12 mt-3">
                          <label for="phoneNumber">Phone Number</label>
                          <input id="phoneNumber" pInputText type="text" formControlName="phoneNumber" maxlength="10"
                              class="col-12 mt-1" />
                          <span
                              *ngIf="findPlanForm.controls['phoneNumber'].touched && findPlanForm.controls['phoneNumber'].invalid">
                              <small class="text-rose-600"
                                  *ngIf="findPlanForm.controls['phoneNumber'].hasError('required')">
                                  {{findPlanConstants.PHONE_NUMBER_REQUIRED_MESSAGE}}
                                  <br>
                              </small>
                              <small class="text-rose-600" *ngIf="findPlanForm.controls['phoneNumber'].touched && (findPlanForm.controls['phoneNumber'].hasError('pattern')||
                              findPlanForm.controls['phoneNumber'].hasError('minlength'))">
                                  {{findPlanConstants.PHONE_NUMBER_INVALID_MESSAGE}}
                              </small>
                          </span>
                      </div>
                  </ng-container>
                  <ng-container *ngSwitchCase=findPlanConstants.PROPERTY>
                      <div class="col-12 mt-3 p-0">
                          <label for="lastName">Last Name</label>
                          <input id="lastName" pInputText type="text" formControlName="lastName" maxlength="30" class="col-12 mt-1" />
                          <span
                              *ngIf="findPlanForm.controls['lastName'].touched && findPlanForm.controls['lastName'].invalid">
                              <small class="text-rose-600"
                                  *ngIf="findPlanForm.controls['lastName'].hasError('required')|| findPlanForm.controls['lastName'].hasError('minlength')">
                                  {{findPlanConstants.LAST_NAME_INVALID_REQUIRED_MESSAGE}}
                              </small>
                          </span>
                      </div>
                      <div class="col-12 mt-3 p-0">
                          <label for="covered">Covered Property</label>
                          <img alt="Covered Property" src="./assets/icons/Property-plan-search.svg" class="col-12 mt-1 p-0" />
                      </div>
                  </ng-container>
                  <ng-container *ngSwitchCase=findPlanConstants.CONTRACT>
                      <div class="col-12 mt-3">
                          <label for="planNumber">Plan Number</label>
                          <input id="planNumber" pInputText type="text" formControlName="planNumber" maxlength="8"
                              class="col-12 mt-1" />
                          <small>{{findPlanConstants.PLAN_NUMBER_MESSAGE}}</small>
                          <br>
                          <span
                              *ngIf="findPlanForm.controls['planNumber'].touched && findPlanForm.controls['planNumber'].invalid">
                              <small class="text-rose-600"
                                  *ngIf="findPlanForm.controls['planNumber'].hasError('required') || findPlanForm.controls['planNumber'].hasError('maxlength')">
                                  {{findPlanConstants.PLAN_NUMBER_REQUIRED_MESSAGE}}
                                  <br>
                              </small>
                              <small class="text-rose-600"
                                  *ngIf="findPlanForm.controls['planNumber'].touched && (findPlanForm.controls['planNumber'].hasError('pattern'))">
                                  {{findPlanConstants.PLAN_NUMBER_INVALID_MESSAGE}}
                              </small>
                          </span>
                      </div>
                  </ng-container>
                  <div [ngClass]="activeLayout===findPlanConstants.PROPERTY?'row':'mt-3'">
                      <div [ngClass]="{'col-6':activeLayout===findPlanConstants.PROPERTY}"
                          *ngIf="activeLayout===findPlanConstants.PROPERTY">
                          <label for="houseNumber">House Number</label>
                          <input id="houseNumber" pInputText type="text" formControlName="houseNumber" maxlength="10" class="col-12 mt-1" />
                          <span
                              *ngIf="findPlanForm.controls['houseNumber'].touched && findPlanForm.controls['houseNumber'].invalid">
                              <small class="text-rose-600"
                                  *ngIf="findPlanForm.controls['houseNumber'].hasError('required')|| findPlanForm.controls['houseNumber'].hasError('minlength')">
                                  {{findPlanConstants.HOUSE_NUMBER_REQUIRED_MESSAGE}}
                              </small>
                          </span>
                      </div>
                      <div [ngClass]="activeLayout===findPlanConstants.PROPERTY?'col-6':'col-12'">
                          <label for="zipCode">ZIP Code</label>
                          <input id="zipCode" pInputText type="text" maxlength="5" minlength="5" formControlName="zipCode"
                              class="col-12 mt-1" />
                          <small *ngIf="activeLayout!=findPlanConstants.PROPERTY">of the covered property
                              <br>
                          </small>
                          <span
                              *ngIf="findPlanForm.controls['zipCode'].touched && findPlanForm.controls['zipCode'].invalid">
                              <small class="text-rose-600"
                                  *ngIf="findPlanForm.controls['zipCode'].hasError('required')">
                                  {{findPlanConstants.ZIP_CODE_REQUIRED_MESSAGE}}
                                  <br>
                              </small>
                              <small class="text-rose-600"
                                  *ngIf="findPlanForm.controls['zipCode'].touched && (findPlanForm.controls['zipCode'].hasError('pattern')|| findPlanForm.controls['zipCode'].hasError('minlength'))">
                                  {{findPlanConstants.ZIP_CODE_INVALID_MESSAGE}}
                              </small>
                          </span>
                      </div>
                  </div>
              </ng-container>
          <div class="col-12 mt-3 full-length">
              <div class="d-grid">
                  <p-button [rounded]="true" severity="primary"  styleClass="w-full"
                      [disabled]="findPlanForm.invalid || loading" (click)="searchPlan()"
                      data-auto-id="fetching-plan-button" type="submit">
                      <ng-container *ngIf="loading">
                          <i class="pi pi-spin pi-spinner"></i>&nbsp;Fetching Plans
                      </ng-container>
                      <ng-container *ngIf="!loading"> Next </ng-container>
                  </p-button>
              </div>
              <div class="mt-3">
                  <p-button
                      [label]="!auth0Userid ? 'Log in' : 'Back'"
                      [rounded]="true"
                      severity="secondary"
                      styleClass="w-full shadow-button bg-white"
                      (click)="navigateToLogIn()"
                      data-auto-id="login-button"
                  />
              </div>
              <div class="col-12 mt-3 text-center">
                  <a
                      href="https://www.cinchhomeservices.com/contact-us/"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-auto-id="need-help-link"
                      class="text-blue-700"
                  >
                      Need help?
                  </a>
              </div>
          </div>
        </form>
      </p-card>
  </div>
</div>
